import React from 'react';
import { Link } from 'react-router-dom';
//import logo from '../logo.png'; // Adjust the path as necessary
// import logo from '../assets/img/logo.svg';
import footerbgshape3 from '../assets/img/shape/footer-bg-shape3.png';

const Footer = () => {
    return (
        <>
            <footer className="footer-wrapper footer-layout1">
                {/* Background Shapes */}
                <div
                    className="shape-mockup footer-bg-shape1-1 jump"
                    data-left={0}
                    data-top={0}
                >
                    {/* <img src="assets/img/shape/footer-bg-shape1-1.png" alt="Background Shape 1" /> */}
                </div>
                <div
                    className="shape-mockup footer-bg-shape1-2 jump-reverse"
                    data-right={0}
                    data-top="15%"
                >
                    <img src={footerbgshape3} alt="Background Shape 2" />
                </div>
                <div
                    className="shape-mockup footer-bg-shape1-3 jump"
                    data-right={0}
                    data-bottom={0}
                >
                    <div className="color-masking2">
                        <div
                            className="masking-src"
                            data-mask-src="assets/img/shape/footer-bg-shape1-2.png"
                        />
                        <img src="assets/img/shape/footer-bg-shape1-2.png" alt="Background Shape 3" />
                    </div>
                </div>

                {/* Widget Area */}
                <div className="widget-area space-top">
                    <div className="container">
                        <div className="row justify-content-between">
                            {/* About Widget */}
                            <div className="col-md-6 col-xl-auto">
                                <div className="widget footer-widget">
                                    <div className="th-widget-about">
                                        <div className="about-logo">
                                            <Link to="/">
                                                {/* <img src={logo} alt="Donat" /> */}
                                            </Link>
                                        </div>
                                        <p className="about-text mb-3">
                                            Our secure online donation platform allows you to make contributions quickly.
                                        </p>
                                        <div className="info-card style2">
                                            <div className="box-icon bg-theme">
                                                <i className="fal fa-phone" />
                                            </div>
                                            <div className="box-content">
                                                <p className="box-text">Call us any time:</p>
                                                <h4 className="box-title">
                                                    <a href="tel:9424385729">9424385729,9399091525</a>
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="info-card style2">
                                            <div className="box-icon bg-theme2">
                                                <i className="fal fa-envelope-open" />
                                            </div>
                                            <div className="box-content">
                                                <p className="box-text">Email us any time:</p>
                                                <h4 className="box-title">
                                                    <a href="mailto:gst_balaghat@yahoo.co.in">gst_balaghat@yahoo.co.in</a>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Quick Links */}
                            <div className="col-sm-6 col-xl-auto">
                                <div className="widget widget_nav_menu footer-widget">
                                    <h3 className="widget_title">Quick Links</h3>
                                    <ul className="menu">
                                        <li><Link to="/about">About Us</Link></li>
                                        <li><Link to="/blog">Our News</Link></li>
                                      
                                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                        <li><Link to="/contact">Contact Us</Link></li>
                                    </ul>
                                </div>
                            </div>

                            {/* Our Service */}
                            <div className="col-sm-6 col-xl-auto">
                                <div className="widget widget_nav_menu footer-widget">
                                    <h3 className="widget_title">Our Service</h3>
                                    <ul className="menu">
                                                           <li><Link to="/about">About Us</Link></li>
                                                           <li><Link to="/resource">Resource</Link></li>
                                                           <li><Link to="/service">Service</Link></li>
                                                           <li><Link to="/gallery">Gallery</Link></li>
                                                           <li><Link to="/contact">Contact Us</Link></li>
                                    </ul>
                                </div>
                            </div>

                            {/* Newsletter */}
                            <div className="col-md-6 col-xl-auto">
                                <div className="widget newsletter-widget footer-widget">
                                    <h3 className="widget_title">Newsletter</h3>
                                    <p className="footer-text mb-4">
                                        Subscribe to Our Newsletter. Regular inspection and feedback mechanisms.
                                    </p>
                                    <form className="newsletter-form">
                                        <div className="form-group style-dark">
                                            <input
                                                className="form-control"
                                                type="email"
                                                placeholder="Enter your email"
                                                required
                                            />
                                        </div>
                                        <button type="submit" className="th-btn style5">
                                            <i className="fas fa-paper-plane" />
                                        </button>
                                    </form>
                                    <div className="th-social style6">
                                        <a href="https://www.facebook.com/"><i className="fab fa-facebook-f" /></a>
                                        <a href="https://www.twitter.com/"><i className="fab fa-twitter" /></a>
                                        <a href="https://www.linkedin.com/"><i className="fab fa-linkedin-in" /></a>
                                        <a href="https://www.behance.com/"><i className="fab fa-behance" /></a>
                                        <a href="https://www.vimeo.com/"><i className="fab fa-vimeo-v" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Copyright Section */}
                <div className="copyright-wrap bg-theme text-center">
                    <div className="container">
                        <p className="copyright-text">
                            Copyright 2024 <Link to="/">Donat.</Link> All Rights Reserved.
                        </p>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;
